import { isPlatformBrowser } from "@angular/common";

/**
 * Window Provider for Angular AOT
 * @returns Browser Window instance
 */
export function getWindow(platformId: any) {
    return isPlatformBrowser(platformId) ? window : {};
}